(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1635],{

/***/ 48387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgGithub(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgGithub);

/***/ }),

/***/ 44257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgGraphql(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.67 3.521l4.523 2.612a1.965 1.965 0 013.125.367 1.965 1.965 0 01-1.242 2.888v5.226a1.955 1.955 0 011.236 2.886 1.964 1.964 0 01-3.164.325l-4.496 2.596A1.963 1.963 0 0111.79 23a1.959 1.959 0 01-1.881-2.515l-4.523-2.612a1.963 1.963 0 11-1.883-3.26V9.388A1.964 1.964 0 012.261 6.5a1.964 1.964 0 013.123-.37L9.91 3.519A1.959 1.959 0 0111.79 1a1.959 1.959 0 011.88 2.521zm-.472.805l4.535 2.618a1.958 1.958 0 001.41 2.44v5.231l-.075.02-5.922-10.257.052-.052v0zm-2.763.053L4.513 14.637a1.877 1.877 0 00-.077-.021V9.383A1.95 1.95 0 005.908 7.72c.032-.261.011-.526-.062-.779l4.534-2.617.055.055v0zm1.903.465l5.92 10.255a1.95 1.95 0 00-.551.957H5.873a1.966 1.966 0 00-.551-.955l5.922-10.256a1.967 1.967 0 001.094 0zm.902 14.874l4.505-2.6a1.981 1.981 0 01-.036-.13H5.87l-.02.077 4.526 2.613a1.955 1.955 0 011.413-.6 1.954 1.954 0 011.45.64z",
    strokeWidth: 0.4
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgGraphql);

/***/ }),

/***/ 29407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgLinkedin(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0z"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgLinkedin);

/***/ }),

/***/ 46396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgRemixArrowDownLine(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgRemixArrowDownLine);

/***/ }),

/***/ 31358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgSlack(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M15.333 0a2 2 0 012 2v6.667a2 2 0 11-4 0V2a2 2 0 012-2zM2 13.333h2v2a2 2 0 11-2-2zM13.333 20h2a2 2 0 11-2 2v-2zm2-6.667H22a2 2 0 010 4h-6.667a2 2 0 010-4zM22 6.667a2 2 0 010 4h-2v-2a2 2 0 012-2zm-20 0h6.667a2 2 0 010 4H2a2 2 0 110-4zM8.667 0a2 2 0 012 2v2h-2a2 2 0 110-4zm0 13.333a2 2 0 012 2V22a2 2 0 01-4 0v-6.667a2 2 0 012-2z"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgSlack);

/***/ }),

/***/ 16432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgTwitter(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M23.954 4.569a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.691 8.094 4.066 6.13 1.64 3.161a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.061a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.937 4.937 0 004.604 3.417 9.868 9.868 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63a9.936 9.936 0 002.46-2.548z"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgTwitter);

/***/ }),

/***/ 24477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgWand(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.245 3.935l.87 1.17c.05.06.05.14.03.21a.2.2 0 01-.18.11l-1.47-.02-.85 1.2c-.03.05-.1.08-.16.08h-.03a.194.194 0 01-.16-.14l-.44-1.4-1.4-.44a.194.194 0 01-.14-.16.2.2 0 01.08-.19l1.2-.85-.02-1.47c0-.08.04-.15.11-.18s.15-.03.21.02l1.17.88 1.39-.47c.08-.02.15 0 .21.05.06.06.07.14.05.21l-.47 1.39zm-16.18 18.22c-.15 0-.31-.06-.42-.18l-2.62-2.62a.61.61 0 010-.85l11.88-11.87.004-.003a.542.542 0 01.151-.11.571.571 0 01.588.029.566.566 0 01.107.084l2.62 2.62c.23.23.23.61 0 .85l-2.97 2.97a.783.783 0 01-.047.037l-8.873 8.873c-.12.11-.27.17-.42.17zm-1.77-3.21l8.062-8.07 1.774 1.767-8.066 8.073-1.77-1.77zm11.03-11.03L16.09 9.68l-2.119 2.121-1.766-1.766 2.12-2.12zm-1.11-4.59l.3-.89c.02-.07.01-.15-.05-.21a.227.227 0 00-.21-.05l-.89.3-.75-.56c-.06-.05-.14-.05-.21-.02a.21.21 0 00-.11.18l.01.94-.77.55a.2.2 0 00-.08.19c.01.08.07.14.14.16l.9.28.28.9c.02.07.08.13.16.14h.03c.06 0 .13-.03.16-.08l.54-.77.94.01a.2.2 0 00.18-.11c.03-.07.03-.15-.02-.21l-.55-.75zm8.61 7.42l-.3.89.55.75c.05.06.05.14.02.21a.2.2 0 01-.18.11l-.94-.01-.54.77c-.03.05-.1.08-.16.08h-.03a.194.194 0 01-.16-.14l-.28-.9-.9-.28a.194.194 0 01-.14-.16.2.2 0 01.08-.19l.77-.55-.01-.94c0-.07.04-.14.11-.18.07-.03.15-.02.21.02l.75.56.89-.3c.08-.02.16 0 .21.05.06.06.07.14.05.21z"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgWand);

/***/ }),

/***/ 81942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgYoutube(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M23.495 6.205a3.007 3.007 0 00-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 00.527 6.205a31.247 31.247 0 00-.522 5.805 31.247 31.247 0 00.522 5.783 3.007 3.007 0 002.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 002.088-2.088 31.247 31.247 0 00.5-5.783 31.247 31.247 0 00-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgYoutube);

/***/ }),

/***/ 86128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "pI": function() { return /* binding */ SalesBreakpoint; },
/* harmony export */   "ok": function() { return /* binding */ SignupBreakpoint; }
/* harmony export */ });
/* unused harmony export CustomBreakpoint */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67576);
/* harmony import */ var _components_SectionHero__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38790);



function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function Breakpoint(_param) {
    var colour = _param.colour, rest = _objectWithoutProperties(_param, [
        "colour"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Section__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        colour: colour || 'dark',
        size: "small",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SectionHero__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
            noHr: true
        }, rest))
    }));
}
function CustomBreakpoint(param) {
    var breakpointTheme = param.breakpointTheme, header = param.header, description = param.description, ctaTheme = param.ctaTheme, primaryCta = param.primaryCta, link = param.link, secondaryCta = param.secondaryCta, link2 = param.link2;
    var props = {
        title: header,
        description: description,
        colour: breakpointTheme,
        ctas: _toConsumableArray(primaryCta ? [
            {
                label: primaryCta,
                href: link,
                colour: ctaTheme,
                appearance: 'regular'
            }, 
        ] : []).concat(_toConsumableArray(secondaryCta ? [
            {
                label: secondaryCta,
                href: link2,
                colour: ctaTheme,
                appearance: 'outline'
            }, 
        ] : []))
    };
    return(/*#__PURE__*/ _jsx(Breakpoint, _objectSpread({}, props)));
}
function SalesBreakpoint() {
    var props = {
        title: "It's Easy To Get Started",
        description: 'GraphCMS plans are flexibly suited to accommodate your growth. Get started for free, or request a demo to discuss larger projects with more complex needs',
        ctas: [
            {
                label: 'Sign up for free',
                href: 'https://app.graphcms.com/signup/',
                appearance: 'outline'
            },
            {
                label: 'Contact sales',
                href: '/contact'
            }, 
        ]
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Breakpoint, _objectSpread({}, props)));
}
function SignupBreakpoint() {
    var props = {
        title: 'Start For Free, Scale As You Grow',
        description: 'Get started in minutes with the fully hosted GraphQL Headless CMS. No credit card or upfront commitments required',
        ctas: [
            {
                label: 'Sign up for free',
                href: 'https://app.graphcms.com/signup/'
            }, 
        ]
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Breakpoint, _objectSpread({}, props)));
}


/***/ }),

/***/ 34465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Heading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var reakit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76152);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var variants = {
    1: "text-3xl md:text-4xl lg:text-5xl",
    2: "text-2xl md:text-3xl lg:text-4xl",
    3: "text-xl md:text-2xl lg:text-3xl",
    4: "text-lg md:text-xl lg:text-2xl",
    5: "text-base md:text-lg lg:text-xl"
};
var elements = {
    1: "h1",
    2: "h2",
    3: "h3",
    4: "h4",
    5: "h5"
};
var keys = {
    h1: 1,
    h2: 2,
    h3: 3,
    h4: 4,
    h5: 5
};
function Heading(_param) {
    var children = _param.children, className = _param.className, _level = _param.level, level = _level === void 0 ? 1 : _level, styleAs = _param.styleAs, props = _objectWithoutProperties(_param, [
        "children",
        "className",
        "level",
        "styleAs"
    ]);
    var as = elements[level];
    var styleVariant = styleAs ? keys[styleAs] : level;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reakit__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, _objectSpread({
        as: as,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(variants[styleVariant], "font-bold leading-snug", className)
    }, props, {
        children: children
    })));
};


/***/ }),

/***/ 1635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ VanillaLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./src/components/Layout/Base.tsx
var Base = __webpack_require__(10787);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Breakpoint.js
var Breakpoint = __webpack_require__(86128);
// EXTERNAL MODULE: ./src/svg/logo.svg
var logo = __webpack_require__(6711);
// EXTERNAL MODULE: ./src/svg/icons/github.svg
var github = __webpack_require__(48387);
// EXTERNAL MODULE: ./src/svg/icons/linkedin.svg
var linkedin = __webpack_require__(29407);
// EXTERNAL MODULE: ./src/svg/icons/twitter.svg
var twitter = __webpack_require__(16432);
// EXTERNAL MODULE: ./src/svg/icons/slack.svg
var slack = __webpack_require__(31358);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/svg/icons/dev-dot-to.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgDevDotTo(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M7.42 10.05c-.18-.16-.46-.23-.84-.23H6l.02 2.44.04 2.45.56-.02c.41 0 .63-.07.83-.26.24-.24.26-.36.26-2.2 0-1.91-.02-1.96-.29-2.18zM0 4.94v14.12h24V4.94zM8.56 15.3c-.44.58-1.06.77-2.53.77H4.71V8.53h1.4c1.67 0 2.16.18 2.6.9.27.43.29.6.32 2.57.05 2.23-.02 2.73-.47 3.3zm5.09-5.47h-2.47v1.77h1.52v1.28l-.72.04-.75.03v1.77l1.22.03 1.2.04v1.28h-1.6c-1.53 0-1.6-.01-1.87-.3l-.3-.28v-3.16c0-3.02.01-3.18.25-3.48.23-.31.25-.31 1.88-.31h1.64v1.3zm4.68 5.45c-.17.43-.64.79-1 .79-.18 0-.45-.15-.67-.39-.32-.32-.45-.63-.82-2.08l-.9-3.39-.45-1.67h.76c.4 0 .75.02.75.05 0 .06 1.16 4.54 1.26 4.83.04.15.32-.7.73-2.3l.66-2.52.74-.04c.4-.02.73 0 .73.04 0 .14-1.67 6.38-1.8 6.68z"
  })));
}

/* harmony default export */ var dev_dot_to = (SvgDevDotTo);
// EXTERNAL MODULE: ./src/svg/icons/youtube.svg
var youtube = __webpack_require__(81942);
// EXTERNAL MODULE: ./src/svg/icons/graphql.svg
var graphql = __webpack_require__(44257);
;// CONCATENATED MODULE: ./src/components/Footer.tsx












function Link(param) {
    var children = param.children, href = param.href;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: href,
        prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "text-sm font-medium text-zodiac hover:text-cornflower",
            children: children
        })
    }));
}
function Footer(param) {
    var _stickyForm = param.stickyForm, stickyForm = _stickyForm === void 0 ? false : _stickyForm, _removeSalesBreakpoint = param.removeSalesBreakpoint, removeSalesBreakpoint = _removeSalesBreakpoint === void 0 ? false : _removeSalesBreakpoint;
    var year = new Date().getFullYear();
    var footerClass = classnames_default()("bg-whisper", {
        'pt-56 md:pt-64': stickyForm
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !removeSalesBreakpoint && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-haiti",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto max-w-6xl px-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "-mx-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breakpoint/* SalesBreakpoint */.pI, {})
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                className: footerClass,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto max-w-6xl px-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "border-b border-primary-100 py-6 md:py-12 lg:py-20",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "-mx-6 md:flex",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-6 md:w-1/4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "mt-6 leading-loose",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "mb-3 text-sm font-medium uppercase tracking-wider text-light-haiti",
                                                    children: "Company"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/about-us",
                                                        children: "About Us"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/contact",
                                                        children: "Contact Sales"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/careers",
                                                        children: "Careers"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/support",
                                                        children: "Support"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/community",
                                                        children: "Community"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/faq",
                                                        children: "FAQ"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/terms",
                                                        children: "Terms"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/privacy",
                                                        children: "Privacy"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/imprint",
                                                        children: "Imprint"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-6 md:w-1/4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "mt-6 leading-loose",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "mb-3 text-sm font-medium uppercase tracking-wider text-light-haiti",
                                                    children: "Key Concepts & Features"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/graphql-headless-cms",
                                                        children: "GraphQL CMS"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/graphql",
                                                        children: "Why A GraphQL CMS?"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/content-federation",
                                                        children: "Content Federation"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/composable-architectures",
                                                        children: "Composable Architectures"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/react-cms",
                                                        children: "React CMS"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/nextjs-cms",
                                                        children: "Next.js CMS"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/gatsby-cms",
                                                        children: "Gatsby CMS"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/vue-cms",
                                                        children: "Vue CMS"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/static-sites",
                                                        children: "Static Sites"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/webhooks",
                                                        children: "Webhooks"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/content-localization",
                                                        children: "Content Localization"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/mutation-api",
                                                        children: "Mutation API"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/query-api",
                                                        children: "Query API"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-6 md:w-1/4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "mt-6 leading-loose",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "mb-3 text-sm font-medium uppercase tracking-wider text-light-haiti",
                                                    children: "Product"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/features",
                                                        children: "Features"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/integrations",
                                                        children: "Integrations"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/for-engineering",
                                                        children: "GraphCMS For Engineering Teams"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/for-content-creators",
                                                        children: "GraphCMS For Content Creators"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/for-businesses",
                                                        children: "GraphCMS For Businesses"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/enterprise-headless-cms",
                                                        children: "For Enterprise"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/partners",
                                                        children: "Partners"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "https://app.drata.com/security-report/f92567d5-4ccc-48c5-aac9-26c77e64c7de/011d58be-23e8-406c-b903-b2c0e6f9b6ec",
                                                        children: "Security"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/pricing",
                                                        children: "Pricing"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/changelog",
                                                        children: "Changelog"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        href: "https://status.graphcms.com",
                                                        className: "text-sm font-medium text-zodiac hover:text-cornflower",
                                                        children: "API Status"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-6 md:w-1/4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "mt-6 leading-loose",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "mb-3 text-sm font-medium uppercase tracking-wider text-light-haiti",
                                                    children: "Resources"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/academy/headless-cms",
                                                        children: "What Is A Headless CMS?"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/academy/what-is-graphql",
                                                        children: "What Is GraphQL?"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/case-studies",
                                                        children: "Customer Case Studies"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/academy",
                                                        children: "Academy"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/docs",
                                                        children: "Documentation"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/resources",
                                                        children: "Resource Hub"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/events",
                                                        children: "Events"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/blog",
                                                        children: "Blog"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/use-cases",
                                                        children: "Solutions"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/customers",
                                                        children: "Customers"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/write-for-graphcms",
                                                        children: "Write for GraphCMS"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                        href: "/newsroom",
                                                        children: "GraphCMS Newsroom"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "py-6 md:py-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "md:flex md:items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-6 flex items-center md:mb-0 md:w-2/5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: "https://github.com/graphcms",
                                                rel: "nofollow noopener noreferrer",
                                                className: "text-light-haiti hover:text-cornflower",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "GitHub"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(github/* default */.Z, {
                                                        className: "h-5 w-5"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: "https://www.linkedin.com/company/graphcms",
                                                rel: "nofollow noopener noreferrer",
                                                className: "ml-6 text-light-haiti hover:text-cornflower",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "LinkedIn"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(linkedin/* default */.Z, {
                                                        className: "h-5 w-5"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: "https://twitter.com/graphcms",
                                                rel: "nofollow noopener noreferrer",
                                                className: "ml-6 text-light-haiti hover:text-cornflower",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Twitter"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(twitter/* default */.Z, {
                                                        className: "h-5 w-5"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: "https://slack.graphcms.com",
                                                rel: "nofollow noopener noreferrer",
                                                className: "ml-6 text-light-haiti hover:text-cornflower",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Slack"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(slack/* default */.Z, {
                                                        className: "h-5 w-5"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: "https://dev.to/graphcms",
                                                rel: "nofollow noopener noreferrer",
                                                className: "ml-6 text-light-haiti hover:text-cornflower",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Dev.to"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dev_dot_to, {
                                                        className: "h-5 w-5"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: "https://www.youtube.com/c/GraphCMS",
                                                rel: "nofollow noopener noreferrer",
                                                className: "ml-6 text-light-haiti hover:text-cornflower",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "YouTube"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube/* default */.Z, {
                                                        className: "h-5 w-5"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: "https://graphqlconf.org",
                                                rel: "nofollow noopener noreferrer",
                                                className: "ml-6 text-light-haiti hover:text-cornflower",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "GraphQL Conf."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(graphql/* default */.Z, {
                                                        className: "h-5 w-5"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "hidden md:flex md:w-1/5 md:items-center md:justify-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* default */.Z, {
                                            className: "h-8 text-haiti"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-sm text-light-haiti md:w-2/5 md:text-right",
                                        children: [
                                            "\xa9 ",
                                            year
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/Button.tsx
var Button = __webpack_require__(68663);
// EXTERNAL MODULE: ./src/components/renderers/Link.tsx
var renderers_Link = __webpack_require__(31515);
;// CONCATENATED MODULE: ./src/components/nav/banner.tsx



var bulletTextVariant = {
    BLACK: "lg:text-white",
    DARK_BLUE: "lg:text-zodiac",
    PINK: "lg:text-rose",
    default: "lg:text-cornflower"
};
var bulletBackgroundVariant = {
    BLACK: "",
    PINK: "bg-faded-rose",
    DARK_BLUE: "",
    default: "bg-faded-cornflower"
};
var bullet = {
    theme: "PINK",
    pill: "Template",
    href: "/resources/headless-cms-rfp-template",
    text: "Evaluating new headless content platforms can be challenging",
    ctaText: "Download our RFP template"
};
function Banner(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("border-b border-primary-100 bg-whisper", className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto flex max-w-6xl items-center justify-center px-4 py-3 lg:justify-between lg:px-6 lg:py-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(renderers_Link/* default */.Z, {
                    href: bullet.href,
                    className: "group flex w-full items-center text-xs font-medium text-haiti sm:text-[15px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("hidden rounded px-2 text-xs uppercase leading-[22px] transition-colors duration-200 lg:inline-block", bulletTextVariant[bullet.theme], bulletBackgroundVariant[bullet.theme]),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: bullet.pill
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "w-full text-center lg:ml-3 lg:w-auto lg:text-left",
                            children: [
                                bullet.text,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "hidden lg:inline-block",
                                    children: ".\xa0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: classnames_default()("text-haiti", bulletTextVariant[bullet.theme]),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "hidden lg:inline-block",
                                            children: bullet.ctaText
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "ml-1 inline-block transform transition-transform duration-100 group-hover:translate-x-1",
                                            children: "→"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "hidden items-center space-x-7 text-sm font-bold lg:flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(renderers_Link/* default */.Z, {
                                href: "/docs",
                                className: "text-haiti transition-colors hover:text-rose",
                                children: "Documentation"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "text-haiti transition-colors hover:text-rose",
                                href: "https://app.graphcms.com",
                                target: "_blank",
                                rel: "nofollow noopener noreferrer",
                                children: "Login"
                            })
                        })
                    ]
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js
var bodyScrollLock_esm = __webpack_require__(58509);
// EXTERNAL MODULE: ./src/svg/icons/remix-arrow-down-line.svg
var remix_arrow_down_line = __webpack_require__(46396);
// EXTERNAL MODULE: ./src/components/nav/item.module.css
var item_module = __webpack_require__(7924);
var item_module_default = /*#__PURE__*/__webpack_require__.n(item_module);
;// CONCATENATED MODULE: ./src/components/nav/item.tsx






function NavItem(param) {
    var label = param.label, content = param.content, href = param.href, onMouseEnter = param.onMouseEnter, dropdownOpen = param.dropdownOpen, isDesktop = param.isDesktop, className = param.className;
    var ref = (0,react.useState)(false), menuOpen = ref[0], setMenuOpen = ref[1];
    var hasSubItems = !!content;
    var DropdownContent = hasSubItems ? content : function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    };
    // toggleMenu is for mobile
    var toggleMenu = function() {
        return setMenuOpen(function(open) {
            return !open;
        });
    };
    var linkClass = classnames_default()("pb-6 lg:pb-0 pl-2 pr-3 lg:px-0 font-bold text-current cursor-pointer lg:text-sm flex items-center justify-between w-full lg:w-auto focus:outline-none transition-colors", {
        'lg:block relative hover:text-rose': !hasSubItems,
        'cursor-default': hasSubItems,
        'lg:!text-rose': dropdownOpen
    }, className);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: hasSubItems ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    className: linkClass,
                    onClick: toggleMenu,
                    "aria-label": label,
                    "aria-haspopup": "true",
                    "aria-expanded": menuOpen || dropdownOpen,
                    onMouseEnter: isDesktop ? onMouseEnter : undefined,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(remix_arrow_down_line/* default */.Z, {
                            className: classnames_default()("hidden h-4 fill-current lg:ml-1 lg:mr-2 lg:inline-block", {
                                'rotate-180 transform md:rotate-0': menuOpen
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "13",
                            height: "8",
                            viewBox: "0 0 13 8",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: classnames_default()("h-4 lg:ml-1 lg:mr-2 lg:hidden", {
                                'rotate-180 transform md:rotate-0': menuOpen
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M1.5 1.5L6.5 6.5L11.5 1.5",
                                stroke: "#626E99",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((item_module_default()).dropdown, dropdownOpen && (item_module_default()).open, menuOpen && "border-catskill-white pb-5 lg:pb-0", "mb-5 border-b border-transparent lg:mb-0 lg:border-none lg:pt-8"),
                    children: (dropdownOpen || menuOpen) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownContent, {
                        isDesktop: isDesktop || false
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(renderers_Link/* default */.Z, {
            href: href,
            className: linkClass,
            children: label
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/nav/dropdown/label.tsx


function Label(param) {
    var children = param.children, className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: classnames_default()("block text-xs font-medium uppercase leading-none tracking-wider text-light-haiti", className),
        children: children
    }));
};

;// CONCATENATED MODULE: ./src/components/nav/dropdown/cta.tsx


function CTA(param) {
    var href = param.href, title = param.title;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: href,
        prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "text-[13px] font-medium text-rose",
            children: [
                title,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "ml-2 inline-block",
                    children: "→"
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/nav/dropdown/column.tsx




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Column(param) {
    var children = param.children, label = param.label, cta = param.cta, className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("flex w-full max-w-full flex-col justify-between lg:max-w-[265px]", !label && "mt-4 lg:mt-10", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-2 lg:px-6 lg:py-6",
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                        className: "pb-5 lg:pb-7",
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid grid-cols-1 space-y-4 lg:space-y-6",
                        children: children
                    })
                ]
            }),
            cta && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-4 mb-0 flex justify-start px-3 lg:mt-0 lg:mb-6 lg:justify-center lg:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CTA, _objectSpread({}, cta))
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/nav/dropdown/content.tsx


function content_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function content_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            content_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Content(param) {
    var children = param.children, cta = param.cta;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "hidden w-full max-w-[360px] flex-col justify-between rounded-r-lg border-l border-catskill-white bg-whisper lg:flex lg:min-w-[360px] lg:px-6 lg:py-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "space-y-4",
                children: children
            }),
            cta && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CTA, content_objectSpread({}, cta))
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
;// CONCATENATED MODULE: ./src/components/nav/dropdown/content-card.tsx




function content_card_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function content_card_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            content_card_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ContentCard(param) {
    var href = param.href, label = param.label, title = param.title, image = param.image;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(renderers_Link/* default */.Z, {
        href: href,
        className: "flex text-haiti transition-colors hover:text-rose",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative mr-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], content_card_objectSpread({
                    src: image.src,
                    alt: image.alt,
                    width: 142,
                    height: 106,
                    quality: 100
                }, image.blurDataURL && {
                    blurDataURL: image.blurDataURL,
                    placeholder: "blur"
                }, {
                    layout: "fixed",
                    className: "max-h-[106px] max-w-[142px] rounded-lg"
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                        children: label
                    }),
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "mt-2 block text-[15px] font-medium leading-[22px]",
                        children: title
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/nav/dropdown/link.tsx



function DropdownLink(param) {
    var href = param.href, title = param.title, subTitle = param.subTitle, Icon = param.icon;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(renderers_Link/* default */.Z, {
        href: href,
        className: classnames_default()("group flex w-full items-center lg:items-start", !subTitle && "!items-center"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex h-5 w-5 flex-shrink-0 items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                    className: "h-4 w-4 text-light-haiti group-hover:text-rose"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ml-3 flex w-full flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "flex-shrink-0 text-[13px] leading-4 text-haiti group-hover:text-rose",
                        children: title
                    }),
                    subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-1 hidden text-xs font-normal leading-4 text-light-haiti lg:inline",
                        children: subTitle
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/nav/dropdown/dropdown.module.css
var dropdown_module = __webpack_require__(25985);
var dropdown_module_default = /*#__PURE__*/__webpack_require__.n(dropdown_module);
;// CONCATENATED MODULE: ./src/components/nav/dropdown/index.tsx



function Dropdown(param) {
    var children = param.children;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("mx-auto flex flex-1 flex-col flex-nowrap justify-center border-catskill-white bg-white lg:flex-row lg:rounded-lg lg:border lg:shadow-dropdown", (dropdown_module_default()).dropdown),
        children: children
    }));
};

;// CONCATENATED MODULE: ./src/components/nav/content/icons.tsx

function Star(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8 10.9994L4.29212 13L5.12013 8.98268L2 6.20177L6.21992 5.71937L8 2L9.78008 5.71937L14 6.20177L10.8799 8.98268L11.7079 13L8 10.9994ZM8 9.83803L10.2327 11.0425L9.73381 8.62392L11.6122 6.94919L9.07141 6.65884L8 4.41961L6.92859 6.65934L4.3878 6.94919L6.26619 8.62392L5.76728 11.0425L8 9.83803Z",
            fill: "currentColor"
        })
    }));
}
function Globe(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8 14C4.6862 14 2 11.3138 2 8C2 4.6862 4.6862 2 8 2C11.3138 2 14 4.6862 14 8C14 11.3138 11.3138 14 8 14ZM6.626 12.6002C6.03405 11.3446 5.69112 9.98613 5.6162 8.6H3.2372C3.35395 9.52334 3.73635 10.3929 4.33794 11.103C4.93953 11.8131 5.73441 12.3333 6.626 12.6002ZM6.818 8.6C6.9086 10.0634 7.3268 11.438 8 12.6512C8.69139 11.4059 9.09527 10.0217 9.182 8.6H6.818ZM12.7628 8.6H10.3838C10.3089 9.98613 9.96595 11.3446 9.374 12.6002C10.2656 12.3333 11.0605 11.8131 11.6621 11.103C12.2636 10.3929 12.646 9.52334 12.7628 8.6ZM3.2372 7.4H5.6162C5.69112 6.01387 6.03405 4.65541 6.626 3.3998C5.73441 3.66673 4.93953 4.18685 4.33794 4.89698C3.73635 5.6071 3.35395 6.47666 3.2372 7.4ZM6.8186 7.4H9.1814C9.09485 5.97836 8.69118 4.59412 8 3.3488C7.30861 4.59407 6.90473 5.97831 6.818 7.4H6.8186ZM9.374 3.3998C9.96595 4.65541 10.3089 6.01387 10.3838 7.4H12.7628C12.646 6.47666 12.2636 5.6071 11.6621 4.89698C11.0605 4.18685 10.2656 3.66673 9.374 3.3998Z",
            fill: "currentColor"
        })
    }));
}
function Building(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M13.3333 12.6667H14.6667V14H0V12.6667H1.33333V2.66667C1.33333 2.48986 1.40357 2.32029 1.5286 2.19526C1.65362 2.07024 1.82319 2 2 2H8.66667C8.84348 2 9.01305 2.07024 9.13807 2.19526C9.26309 2.32029 9.33333 2.48986 9.33333 2.66667V12.6667H12V7.33333H10.6667V6H12.6667C12.8435 6 13.013 6.07024 13.1381 6.19526C13.2631 6.32029 13.3333 6.48986 13.3333 6.66667V12.6667ZM2.66667 3.33333V12.6667H8V3.33333H2.66667ZM4 7.33333H6.66667V8.66667H4V7.33333ZM4 4.66667H6.66667V6H4V4.66667Z",
            fill: "currentColor"
        })
    }));
}
function Security(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M2.4785 2.162L7.5 1L12.5215 2.162C12.6572 2.19341 12.7786 2.27207 12.8656 2.38498C12.9526 2.4979 13 2.63833 13 2.78309V9.13845C13 9.76701 12.8509 10.3858 12.566 10.94C12.2812 11.4942 11.8694 11.9665 11.3671 12.3152L7.5 15L3.63289 12.3152C3.13072 11.9666 2.71895 11.4943 2.4341 10.9403C2.14926 10.3862 2.00014 9.76754 2 9.13909V2.78309C2.00002 2.63833 2.04745 2.4979 2.13444 2.38498C2.22143 2.27207 2.34279 2.19341 2.4785 2.162ZM3.22222 3.29345V9.13845C3.22223 9.55747 3.32157 9.97001 3.51144 10.3395C3.7013 10.7089 3.97581 11.0238 4.31061 11.2563L7.5 13.4708L10.6894 11.2563C11.0241 11.0239 11.2986 10.7091 11.4884 10.3397C11.6783 9.97041 11.7777 9.558 11.7778 9.13909V3.29345L7.5 2.30455L3.22222 3.29345ZM7.5 7.36364C7.09481 7.36364 6.70621 7.19602 6.4197 6.89767C6.13318 6.59932 5.97222 6.19466 5.97222 5.77273C5.97222 5.35079 6.13318 4.94614 6.4197 4.64778C6.70621 4.34943 7.09481 4.18182 7.5 4.18182C7.90519 4.18182 8.29379 4.34943 8.5803 4.64778C8.86682 4.94614 9.02778 5.35079 9.02778 5.77273C9.02778 6.19466 8.86682 6.59932 8.5803 6.89767C8.29379 7.19602 7.90519 7.36364 7.5 7.36364ZM4.7665 10.5455C4.84058 9.84444 5.16047 9.19654 5.66488 8.72591C6.16929 8.25529 6.82274 7.99504 7.5 7.99504C8.17726 7.99504 8.83071 8.25529 9.33512 8.72591C9.83953 9.19654 10.1594 9.84444 10.2335 10.5455H4.7665Z",
            fill: "currentColor"
        })
    }));
}
function Loader(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.4241 2.70311C4.69429 1.60247 6.31929 0.997662 8 1.00001C11.8661 1.00001 15 4.1339 15 8C15 9.4952 14.531 10.8812 13.733 12.018L11.5 8H13.6C13.6001 6.90214 13.2775 5.82846 12.6723 4.91248C12.0671 3.9965 11.206 3.27862 10.196 2.84809C9.1861 2.41757 8.0719 2.2934 6.99197 2.49102C5.91204 2.68864 4.91402 3.19933 4.122 3.9596L3.4241 2.70311ZM12.5759 13.2969C11.3057 14.3975 9.68071 15.0023 8 15C4.1339 15 1 11.8661 1 8C1 6.5048 1.469 5.1188 2.267 3.982L4.5 8H2.4C2.39991 9.09786 2.72253 10.1715 3.32774 11.0875C3.93294 12.0035 4.79405 12.7214 5.80397 13.1519C6.8139 13.5824 7.9281 13.7066 9.00803 13.509C10.088 13.3114 11.086 12.8007 11.878 12.0404L12.5759 13.2969Z",
            fill: "currentColor"
        })
    }));
}
function Paper(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M13.3889 14H3.61111C3.44903 14 3.2936 13.9368 3.17899 13.8243C3.06438 13.7117 3 13.5591 3 13.4V2.6C3 2.44087 3.06438 2.28826 3.17899 2.17574C3.2936 2.06321 3.44903 2 3.61111 2H13.3889C13.551 2 13.7064 2.06321 13.821 2.17574C13.9356 2.28826 14 2.44087 14 2.6V13.4C14 13.5591 13.9356 13.7117 13.821 13.8243C13.7064 13.9368 13.551 14 13.3889 14ZM12.7778 12.8V3.2H4.22222V12.8H12.7778ZM5.44444 4.4H7.88889V6.8H5.44444V4.4ZM5.44444 8H11.5556V9.2H5.44444V8ZM5.44444 10.4H11.5556V11.6H5.44444V10.4ZM9.11111 5H11.5556V6.2H9.11111V5Z",
            fill: "currentColor"
        })
    }));
}
function Structure(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M2.66667 14C2.48986 14 2.32029 13.9298 2.19526 13.8047C2.07024 13.6797 2 13.5101 2 13.3333V2.66667C2 2.48986 2.07024 2.32029 2.19526 2.19526C2.32029 2.07024 2.48986 2 2.66667 2H13.3333C13.5101 2 13.6797 2.07024 13.8047 2.19526C13.9298 2.32029 14 2.48986 14 2.66667V13.3333C14 13.5101 13.9298 13.6797 13.8047 13.8047C13.6797 13.9298 13.5101 14 13.3333 14H2.66667ZM5.33333 6.66667H3.33333V12.6667H5.33333V6.66667ZM12.6667 6.66667H6.66667V12.6667H12.6667V6.66667ZM12.6667 3.33333H3.33333V5.33333H12.6667V3.33333Z",
            fill: "currentColor"
        })
    }));
}
function Cart(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.1583 10V3.14286H2V2H3.73745C3.89105 2 4.03836 2.0602 4.14698 2.16737C4.25559 2.27453 4.31661 2.41988 4.31661 2.57143V9.42857H11.5201L12.6784 4.85714H5.47491V3.71429H13.4209C13.5089 3.71429 13.5958 3.73409 13.6749 3.77219C13.754 3.81029 13.8233 3.86569 13.8774 3.93416C13.9316 4.00264 13.9692 4.0824 13.9874 4.16738C14.0057 4.25235 14.004 4.34031 13.9826 4.42457L12.5348 10.1389C12.5034 10.2624 12.4311 10.3721 12.3293 10.4505C12.2275 10.5289 12.1021 10.5714 11.973 10.5714H3.73745C3.58385 10.5714 3.43654 10.5112 3.32793 10.4041C3.21932 10.2969 3.1583 10.1516 3.1583 10ZM4.31661 14C4.0094 14 3.71479 13.8796 3.49756 13.6653C3.28034 13.4509 3.1583 13.1602 3.1583 12.8571C3.1583 12.554 3.28034 12.2633 3.49756 12.049C3.71479 11.8347 4.0094 11.7143 4.31661 11.7143C4.62381 11.7143 4.91842 11.8347 5.13565 12.049C5.35287 12.2633 5.47491 12.554 5.47491 12.8571C5.47491 13.1602 5.35287 13.4509 5.13565 13.6653C4.91842 13.8796 4.62381 14 4.31661 14ZM11.2664 14C10.9592 14 10.6646 13.8796 10.4474 13.6653C10.2302 13.4509 10.1081 13.1602 10.1081 12.8571C10.1081 12.554 10.2302 12.2633 10.4474 12.049C10.6646 11.8347 10.9592 11.7143 11.2664 11.7143C11.5736 11.7143 11.8682 11.8347 12.0855 12.049C12.3027 12.2633 12.4247 12.554 12.4247 12.8571C12.4247 13.1602 12.3027 13.4509 12.0855 13.6653C11.8682 13.8796 11.5736 14 11.2664 14Z",
            fill: "currentColor"
        })
    }));
}
function Academy(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.58333 2H12.9167C13.0714 2 13.2197 2.06146 13.3291 2.17085C13.4385 2.28025 13.5 2.42862 13.5 2.58333V13.8277C13.5 13.8763 13.4879 13.9242 13.4647 13.967C13.4415 14.0098 13.408 14.0461 13.3671 14.0726C13.3263 14.0991 13.2795 14.115 13.231 14.1187C13.1825 14.1225 13.1338 14.1141 13.0893 14.0942L8.25 11.9342L3.41067 14.0937C3.36628 14.1135 3.31763 14.1219 3.26916 14.1182C3.22068 14.1144 3.17391 14.0986 3.1331 14.0722C3.09229 14.0457 3.05874 14.0095 3.0355 13.9668C3.01225 13.9241 3.00005 13.8763 3 13.8277V2.58333C3 2.42862 3.06146 2.28025 3.17085 2.17085C3.28025 2.06146 3.42862 2 3.58333 2ZM12.3333 12.4796V3.16667H4.16667V12.4796L8.25 10.6572L12.3333 12.4796ZM8.25 8.70833L6.53558 9.60958L6.86283 7.70092L5.47625 6.34875L7.39308 6.06992L8.25 4.33333L9.1075 6.06992L11.0237 6.34875L9.63717 7.70092L9.96383 9.60958L8.25 8.70833Z",
            fill: "currentColor"
        })
    }));
}
function Resources(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.3 5.33333H13.7V3.33333H3.3V5.33333ZM9.8 12.6667V6.66667H7.2V12.6667H9.8ZM11.1 12.6667H13.7V6.66667H11.1V12.6667ZM5.9 12.6667V6.66667H3.3V12.6667H5.9ZM2.65 2H14.35C14.5224 2 14.6877 2.07024 14.8096 2.19526C14.9315 2.32029 15 2.48986 15 2.66667V13.3333C15 13.5101 14.9315 13.6797 14.8096 13.8047C14.6877 13.9298 14.5224 14 14.35 14H2.65C2.47761 14 2.31228 13.9298 2.19038 13.8047C2.06848 13.6797 2 13.5101 2 13.3333V2.66667C2 2.48986 2.06848 2.32029 2.19038 2.19526C2.31228 2.07024 2.47761 2 2.65 2Z",
            fill: "currentColor"
        })
    }));
}
function Calendar(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M11.25 3.1H13.45C13.5959 3.1 13.7358 3.15795 13.8389 3.26109C13.9421 3.36424 14 3.50413 14 3.65V12.45C14 12.5959 13.9421 12.7358 13.8389 12.8389C13.7358 12.9421 13.5959 13 13.45 13H3.55C3.40413 13 3.26424 12.9421 3.16109 12.8389C3.05795 12.7358 3 12.5959 3 12.45V3.65C3 3.50413 3.05795 3.36424 3.16109 3.26109C3.26424 3.15795 3.40413 3.1 3.55 3.1H5.75V2H6.85V3.1H10.15V2H11.25V3.1ZM12.9 6.4V4.2H11.25V5.3H10.15V4.2H6.85V5.3H5.75V4.2H4.1V6.4H12.9ZM12.9 7.5H4.1V11.9H12.9V7.5ZM5.2 8.6H7.95V10.8H5.2V8.6Z",
            fill: "currentColor"
        })
    }));
}
function Newspaper(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M10.3333 12.6667V3.33335H3.33329V12.0834C3.33329 12.2381 3.39475 12.3864 3.50415 12.4958C3.61354 12.6052 3.76192 12.6667 3.91663 12.6667H10.3333ZM12.0833 13.8334H3.91663C3.4525 13.8334 3.00738 13.649 2.67919 13.3208C2.351 12.9926 2.16663 12.5475 2.16663 12.0834V2.75002C2.16663 2.59531 2.22808 2.44694 2.33748 2.33754C2.44688 2.22815 2.59525 2.16669 2.74996 2.16669H10.9166C11.0713 2.16669 11.2197 2.22815 11.3291 2.33754C11.4385 2.44694 11.5 2.59531 11.5 2.75002V6.83335H13.8333V12.0834C13.8333 12.5475 13.6489 12.9926 13.3207 13.3208C12.9925 13.649 12.5474 13.8334 12.0833 13.8334ZM11.5 8.00002V12.0834C11.5 12.2381 11.5614 12.3864 11.6708 12.4958C11.7802 12.6052 11.9286 12.6667 12.0833 12.6667C12.238 12.6667 12.3864 12.6052 12.4958 12.4958C12.6052 12.3864 12.6666 12.2381 12.6666 12.0834V8.00002H11.5ZM4.49996 4.50002H7.99996V8.00002H4.49996V4.50002ZM5.66663 5.66669V6.83335H6.83329V5.66669H5.66663ZM4.49996 8.58335H9.16663V9.75002H4.49996V8.58335ZM4.49996 10.3334H9.16663V11.5H4.49996V10.3334Z",
            fill: "currentColor"
        })
    }));
}
function Question(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8 14C4.6862 14 2 11.3138 2 8C2 4.6862 4.6862 2 8 2C11.3138 2 14 4.6862 14 8C14 11.3138 11.3138 14 8 14ZM8 12.8C9.27304 12.8 10.4939 12.2943 11.3941 11.3941C12.2943 10.4939 12.8 9.27304 12.8 8C12.8 6.72696 12.2943 5.50606 11.3941 4.60589C10.4939 3.70571 9.27304 3.2 8 3.2C6.72696 3.2 5.50606 3.70571 4.60589 4.60589C3.70571 5.50606 3.2 6.72696 3.2 8C3.2 9.27304 3.70571 10.4939 4.60589 11.3941C5.50606 12.2943 6.72696 12.8 8 12.8ZM7.4 9.8H8.6V11H7.4V9.8ZM8.6 8.813V9.2H7.4V8.3C7.4 8.14087 7.46321 7.98826 7.57574 7.87574C7.68826 7.76321 7.84087 7.7 8 7.7C8.17045 7.69999 8.33739 7.65158 8.4814 7.5604C8.6254 7.46922 8.74056 7.33902 8.81346 7.18495C8.88637 7.03088 8.91402 6.85928 8.89321 6.69011C8.8724 6.52093 8.80397 6.36115 8.6959 6.22935C8.58783 6.09754 8.44455 5.99914 8.28273 5.94558C8.12092 5.89203 7.94722 5.88552 7.78186 5.92682C7.61649 5.96813 7.46625 6.05554 7.34862 6.17889C7.23099 6.30224 7.15081 6.45646 7.1174 6.6236L5.9402 6.3878C6.01318 6.02305 6.18171 5.68422 6.42855 5.40595C6.6754 5.12768 6.99171 4.91995 7.34515 4.80399C7.6986 4.68803 8.07649 4.66801 8.44021 4.74597C8.80393 4.82393 9.14042 4.99707 9.41529 5.24769C9.69016 5.49832 9.89355 5.81744 10.0047 6.17244C10.1158 6.52743 10.1306 6.90557 10.0477 7.26818C9.9648 7.6308 9.78707 7.9649 9.53271 8.23632C9.27835 8.50774 8.95648 8.70675 8.6 8.813Z",
            fill: "currentColor"
        })
    }));
}
function Write(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5.46567 11.7939L12.7904 4.68407L11.7692 3.69282L4.44444 10.8026V11.7939H5.46567ZM6.06439 13.1959H3V10.2215L11.2586 2.20525C11.394 2.07383 11.5777 2 11.7692 2C11.9607 2 12.1444 2.07383 12.2798 2.20525L14.323 4.18845C14.4584 4.31991 14.5345 4.49818 14.5345 4.68407C14.5345 4.86996 14.4584 5.04823 14.323 5.17969L6.06439 13.1959ZM3 14.598H16V16H3V14.598Z",
            fill: "currentColor"
        })
    }));
}
function Flow(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8.58333 5.66669V10.3334C8.58333 10.7975 8.39896 11.2426 8.07077 11.5708C7.74258 11.899 7.29746 12.0834 6.83333 12.0834H5.5675C5.42989 12.4727 5.15905 12.8009 4.80286 13.0099C4.44667 13.2189 4.02807 13.2952 3.62104 13.2254C3.21401 13.1556 2.84477 12.9441 2.57857 12.6284C2.31238 12.3127 2.16638 11.913 2.16638 11.5C2.16638 11.087 2.31238 10.6874 2.57857 10.3716C2.84477 10.0559 3.21401 9.84444 3.62104 9.77463C4.02807 9.70482 4.44667 9.78116 4.80286 9.99014C5.15905 10.1991 5.42989 10.5273 5.5675 10.9167H6.83333C6.98804 10.9167 7.13642 10.8552 7.24581 10.7458C7.35521 10.6364 7.41667 10.4881 7.41667 10.3334V5.66669C7.41667 5.20256 7.60104 4.75744 7.92923 4.42925C8.25742 4.10106 8.70254 3.91669 9.16667 3.91669H10.9167V2.16669L13.8333 4.50002L10.9167 6.83335V5.08335H9.16667C9.01196 5.08335 8.86358 5.14481 8.75419 5.25421C8.64479 5.3636 8.58333 5.51198 8.58333 5.66669ZM3.91667 12.0834C4.07138 12.0834 4.21975 12.0219 4.32915 11.9125C4.43854 11.8031 4.5 11.6547 4.5 11.5C4.5 11.3453 4.43854 11.1969 4.32915 11.0875C4.21975 10.9781 4.07138 10.9167 3.91667 10.9167C3.76196 10.9167 3.61358 10.9781 3.50419 11.0875C3.39479 11.1969 3.33333 11.3453 3.33333 11.5C3.33333 11.6547 3.39479 11.8031 3.50419 11.9125C3.61358 12.0219 3.76196 12.0834 3.91667 12.0834Z",
            fill: "currentColor"
        })
    }));
}
function UIExtensions(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.33333 3.33333H6V6H3.33333V3.33333ZM2 3.33333C2 2.59695 2.59695 2 3.33333 2H6C6.73638 2 7.33333 2.59695 7.33333 3.33333V6C7.33333 6.73638 6.73638 7.33333 6 7.33333H3.33333C2.59695 7.33333 2 6.73638 2 6V3.33333ZM3.33333 10H6V12.6667H3.33333V10ZM2 10C2 9.26362 2.59695 8.66667 3.33333 8.66667H6C6.73638 8.66667 7.33333 9.26362 7.33333 10V12.6667C7.33333 13.403 6.73638 14 6 14H3.33333C2.59695 14 2 13.403 2 12.6667V10ZM12.6667 3.33333H10V6H12.6667V3.33333ZM10 2C9.26362 2 8.66667 2.59695 8.66667 3.33333V6C8.66667 6.73638 9.26362 7.33333 10 7.33333H12.6667C13.403 7.33333 14 6.73638 14 6V3.33333C14 2.59695 13.403 2 12.6667 2H10ZM10 10H12.6667V12.6667H10V10ZM8.66667 10C8.66667 9.26362 9.26362 8.66667 10 8.66667H12.6667C13.403 8.66667 14 9.26362 14 10V12.6667C14 13.403 13.403 14 12.6667 14H10C9.26362 14 8.66667 13.403 8.66667 12.6667V10Z",
            fill: "currentColor"
        })
    }));
}
function Management(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3 11H6.5V12H3V11ZM3 7.5H7.5V8.5H3V7.5ZM3 4H13V5H3V4ZM12.337 8.5125L12.915 8.317L13.415 9.183L12.957 9.5855C13.0146 9.85883 13.0146 10.1412 12.957 10.4145L13.415 10.817L12.915 11.683L12.337 11.4875C12.132 11.6725 11.888 11.815 11.6195 11.9025L11.5 12.5H10.5L10.38 11.902C10.1146 11.8153 9.87038 11.6739 9.663 11.487L9.085 11.683L8.585 10.817L9.043 10.4145C8.98535 10.1412 8.98535 9.85883 9.043 9.5855L8.585 9.183L9.085 8.317L9.663 8.5125C9.868 8.3275 10.112 8.185 10.3805 8.0975L10.5 7.5H11.5L11.62 8.098C11.888 8.185 12.132 8.328 12.337 8.513V8.5125ZM11 10.5C11.1326 10.5 11.2598 10.4473 11.3536 10.3536C11.4473 10.2598 11.5 10.1326 11.5 10C11.5 9.86739 11.4473 9.74021 11.3536 9.64645C11.2598 9.55268 11.1326 9.5 11 9.5C10.8674 9.5 10.7402 9.55268 10.6464 9.64645C10.5527 9.74021 10.5 9.86739 10.5 10C10.5 10.1326 10.5527 10.2598 10.6464 10.3536C10.7402 10.4473 10.8674 10.5 11 10.5Z",
            fill: "currentColor"
        })
    }));
}
function Stack(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14.0141 10.348L14.8341 10.8283C14.8847 10.8579 14.9266 10.8997 14.9556 10.9498C14.9847 10.9999 15 11.0565 15 11.1141C15 11.1716 14.9847 11.2282 14.9556 11.2783C14.9266 11.3284 14.8847 11.3702 14.8341 11.3998L8.85133 14.9049C8.74522 14.9671 8.62378 15 8.5 15C8.37622 15 8.25478 14.9671 8.14867 14.9049L2.16589 11.3998C2.1153 11.3702 2.07343 11.3284 2.04436 11.2783C2.01528 11.2282 2 11.1716 2 11.1141C2 11.0565 2.01528 10.9999 2.04436 10.9498C2.07343 10.8997 2.1153 10.8579 2.16589 10.8283L2.98588 10.348L8.5 13.5787L14.0141 10.348ZM14.0141 7.21732L14.8341 7.69759C14.8847 7.72716 14.9266 7.76903 14.9556 7.81911C14.9847 7.86919 15 7.92578 15 7.98335C15 8.04092 14.9847 8.0975 14.9556 8.14758C14.9266 8.19767 14.8847 8.23954 14.8341 8.26911L8.5 11.98L2.16589 8.26911C2.1153 8.23954 2.07343 8.19767 2.04436 8.14758C2.01528 8.0975 2 8.04092 2 7.98335C2 7.92578 2.01528 7.86919 2.04436 7.81911C2.07343 7.76903 2.1153 7.72716 2.16589 7.69759L2.98588 7.21732L8.5 10.4479L14.0141 7.21732ZM8.85064 1.09513L14.8341 4.60019C14.8847 4.62976 14.9266 4.67163 14.9556 4.72171C14.9847 4.77179 15 4.82838 15 4.88595C15 4.94352 14.9847 5.0001 14.9556 5.05018C14.9266 5.10027 14.8847 5.14214 14.8341 5.17171L8.5 8.88259L2.16589 5.17171C2.1153 5.14214 2.07343 5.10027 2.04436 5.05018C2.01528 5.0001 2 4.94352 2 4.88595C2 4.82838 2.01528 4.77179 2.04436 4.72171C2.07343 4.67163 2.1153 4.62976 2.16589 4.60019L8.14867 1.09513C8.25478 1.03288 8.37622 1 8.5 1C8.62378 1 8.74522 1.03288 8.85133 1.09513H8.85064ZM8.5 2.44266L4.32979 4.88595L8.5 7.32923L12.6702 4.88595L8.5 2.44266Z",
            fill: "currentColor"
        })
    }));
}
function Showcase(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.17551 1L10.393 5.49298L14.0251 6.02091L13.8862 6.98658L10.2526 6.45767L9.74564 6.38407L9.51848 5.92439L8.17551 3.20286L6.83254 5.92439L6.60538 6.38407L6.09841 6.45767L3.09513 6.89396L5.26826 9.01297L5.63532 9.37029L5.54855 9.87579L5.03574 12.8669L7.20057 11.7287V12.8303L3.74054 14.6491L4.58775 9.71103L1 6.21345L5.95802 5.49298L8.17551 1ZM15 8.7995H9.15037V9.77444H15V8.7995ZM9.15037 10.7493H15V11.7242H9.15037V10.7493ZM9.15037 12.6993H13.0501V13.6742H9.15037V12.6993Z",
            fill: "currentColor"
        })
    }));
}
function Community(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5.25305 13.1473L2.16663 13.8333L2.85263 10.7469C2.40086 9.9019 2.16519 8.95822 2.16663 8.00001C2.16663 4.77826 4.77822 2.16667 7.99997 2.16667C11.2217 2.16667 13.8333 4.77826 13.8333 8.00001C13.8333 11.2218 11.2217 13.8333 7.99997 13.8333C7.04176 13.8348 6.09808 13.5991 5.25305 13.1473ZM5.42222 11.9148L5.80313 12.1189C6.47895 12.4801 7.2337 12.6683 7.99997 12.6667C8.92295 12.6667 9.8252 12.393 10.5926 11.8802C11.3601 11.3674 11.9582 10.6386 12.3114 9.78586C12.6646 8.93314 12.757 7.99483 12.577 7.08958C12.3969 6.18434 11.9524 5.35282 11.2998 4.70017C10.6472 4.04753 9.81563 3.60307 8.91039 3.42301C8.00514 3.24294 7.06683 3.33536 6.21411 3.68857C5.36139 4.04178 4.63255 4.63991 4.11977 5.40734C3.60699 6.17477 3.3333 7.07703 3.3333 8.00001C3.3333 8.77817 3.52288 9.52717 3.88163 10.1968L4.08522 10.5778L3.70313 12.2968L5.42222 11.9148Z",
            fill: "currentColor"
        })
    }));
}
function GraphCMS(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.3999 2.86664L8.79997 3.80003L7.20003 4.73328L5.59995 5.66667V7.53331V8.46669V9.39995V10.3333V11.2667L7.20003 10.3333L8.79997 9.39995V8.46669V7.53331L7.20003 8.46669V6.60005L8.79997 5.66667L10.3999 4.73328V5.66667V6.60005V7.53331V8.46669V9.39995V10.3333L8.79997 11.2667L7.20003 12.2L5.59995 13.1334L4 14.0666L5.59995 15L7.20003 14.0666L8.79997 13.1334L10.3999 12.2L12 11.2667V9.39995V7.53331V5.66667V4.95074V3.80003V1.93339L10.3999 1V2.86664Z",
            fill: "currentColor"
        })
    }));
}

;// CONCATENATED MODULE: ./src/components/nav/content/developers.tsx







function Developers(param) {
    var isDesktop = param.isDesktop;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column, {
                label: "Developer Resources",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/docs",
                        title: "Documentation",
                        subTitle: "GraphCMS API Reference",
                        icon: Paper
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/docs/guides",
                        title: "User Guides",
                        subTitle: "For project managers and content editors",
                        icon: Flow
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/docs/ui-extensions",
                        title: "UI Extensions",
                        subTitle: "Make GraphCMS your own",
                        icon: UIExtensions
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "https://github.com/graphcms/management-sdk",
                        title: "Management SDK",
                        subTitle: "Programmatically manage GraphCMS projects",
                        icon: Management
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "https://github.com/graphcms/graphcms-examples",
                        title: "Code Examples",
                        subTitle: "Quickstarts to get you going",
                        icon: Stack
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/showcase",
                        title: "Showcase",
                        subTitle: "See what others are building",
                        icon: Showcase
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/community",
                        title: "Community",
                        subTitle: "Come, join us!",
                        icon: Community
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "https://www.youtube.com/playlist?list=PL5SvzogSTpeFSjhoWcXLDjuN2EYli78xd",
                        title: "How to GraphCMS",
                        subTitle: "Quick videos to get you up and running",
                        icon: GraphCMS
                    })
                ]
            }),
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCard, {
                        href: "https://app.graphcms.com/signup",
                        label: "Get started",
                        image: {
                            src: "/images/nav/signup.svg",
                            blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAIAAAA7ljmRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMklEQVQImQEnANj/AAAAWGhhn3Fqpj47hgAAD2n9/f/////HxNwAAABdhX+wnZe/bGWhRpgSjBAxC0kAAAAASUVORK5CYII="
                        },
                        title: "Create a free-forever developer account"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCard, {
                        href: "/blog/forms-and-submissions-with-nextjs-and-graphql",
                        label: "Blog",
                        image: {
                            src: "/images/nav/forms-nextjs.svg",
                            blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAIAAAA7ljmRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAL0lEQVQImWMwZVCyY9AyZVAyZVBiyGII+n/1fwN/ehyDB4MPg0UMg2sMg6sPgwUAplcI4w2mDskAAAAASUVORK5CYII="
                        },
                        title: "Programmatic forms with Next.js and GraphCMS"
                    })
                ]
            })
        ]
    }));
}

;// CONCATENATED MODULE: ./src/components/nav/dropdown/persona-link.tsx



var iconVariants = {
    purple: "bg-faded-cornflower text-cornflower group-hover:bg-cornflower group-hover:text-white",
    rose: "bg-lavender-blush text-rose group-hover:bg-rose group-hover:text-white",
    blue: "bg-faded-blue text-strong-blue group-hover:bg-strong-blue group-hover:text-white"
};
var linkVariants = {
    purple: "hover:text-cornflower lg:hover:bg-faded-cornflower",
    rose: "hover:text-rose lg:hover:bg-lavender-blush",
    blue: "hover:text-strong-blue lg:hover:bg-faded-blue"
};
var arrowColors = {
    purple: "text-cornflower",
    rose: "text-rose",
    blue: "text-strong-blue"
};
function PersonaLink(param) {
    var href = param.href, title = param.title, subTitle = param.subTitle, Icon = param.icon, className = param.className, variant = param.variant;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(renderers_Link/* default */.Z, {
        href: href,
        className: classnames_default()("group flex items-center rounded-lg text-haiti transition-colors lg:min-h-[60px] lg:px-3 lg:py-2", className, linkVariants[variant]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("flex h-6 w-6 flex-shrink-0 items-center justify-center rounded transition-colors duration-100 lg:h-10 lg:w-10", iconVariants[variant]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                    className: "h-3 w-3 text-[color:inherit] transition-colors duration-75 lg:h-[22px] lg:w-[22px]"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ml-3 flex w-full items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "block text-[13px] font-medium",
                                children: title
                            }),
                            subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "hidden text-xs text-light-haiti lg:block",
                                children: subTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()("invisible hidden text-xl group-hover:visible lg:inline-block", arrowColors[variant]),
                        children: "→"
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/svg/icons/wand.svg
var wand = __webpack_require__(24477);
// EXTERNAL MODULE: ./src/components/icons/personas/index.ts + 3 modules
var personas = __webpack_require__(39685);
;// CONCATENATED MODULE: ./src/components/nav/content/product.tsx











function Product(param) {
    var isDesktop = param.isDesktop;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-5 flex w-full max-w-full flex-shrink-0 flex-col justify-between border-b border-catskill-white pb-5 lg:mb-0 lg:max-w-[315px] lg:border-r lg:border-b-0 lg:pb-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-2 lg:py-6 lg:pl-9 lg:pr-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                            className: "pb-5 lg:pb-7",
                            children: "GraphCMS for"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid grid-cols-1 space-y-4 lg:-mx-3 lg:space-y-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonaLink, {
                                    href: "/for-engineering",
                                    title: "Engineering Teams",
                                    subTitle: "Build. On your terms",
                                    icon: personas/* Engineering */.se,
                                    variant: "purple"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonaLink, {
                                    href: "/for-content-creators",
                                    title: "Content Creators",
                                    subTitle: "Deliver perfect experiences",
                                    icon: personas/* Creators */.y2,
                                    variant: "rose"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonaLink, {
                                    href: "/for-businesses",
                                    title: "Businesses",
                                    subTitle: "Scale in all directions",
                                    icon: personas/* Businesses */.Jl,
                                    variant: "blue"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column, {
                label: "Platform",
                className: "lg:min-w-[245px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/product",
                        title: "Product",
                        icon: Star
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/features",
                        title: "Features",
                        icon: wand/* default */.Z
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/partners",
                        title: "Partners",
                        icon: Globe
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/enterprise-headless-cms",
                        title: "Enterprise",
                        icon: Building
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/security-and-compliance",
                        title: "Security & Compliance",
                        icon: Security
                    })
                ]
            }),
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCard, {
                        href: "https://app.graphcms.com/signup",
                        label: "Get started",
                        image: {
                            src: "/images/nav/signup.svg",
                            blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAIAAAA7ljmRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMklEQVQImQEnANj/AAAAWGhhn3Fqpj47hgAAD2n9/f/////HxNwAAABdhX+wnZe/bGWhRpgSjBAxC0kAAAAASUVORK5CYII="
                        },
                        title: "Create a free-forever developer account"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCard, {
                        href: "/partners",
                        label: "Partners",
                        image: {
                            src: "/images/nav/headless-cms.svg",
                            blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAIAAAA7ljmRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMklEQVQImQEnANj/AKc2ZNyUrd+atGUAHwDbk6r/+v/p3OnRgJ0AUAAA9sfb25Oqs01yrc8WLomBPwgAAAAASUVORK5CYII="
                        },
                        title: "Join our global partner program"
                    })
                ]
            })
        ]
    }));
}

;// CONCATENATED MODULE: ./public/images/nav/dxp-report.png
/* harmony default export */ var dxp_report = ({"src":"/_next/static/media/dxp-report.bcdbbd56.png","height":212,"width":284,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAG1BMVEUACj4gHFEBCkEACkMICTQOF1UcI2kVEkADBScrXYFWAAAAAnRSTlPs/DBTz+8AAAAJcEhZcwAACxMAAAsTAQCanBgAAAAqSURBVAiZNcbBDQAgCATBgz2B/is2anzNSEB6dK2YOaHKfmkjyLXc+RMbEqMAt9KOhGUAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/components/nav/content/resources.tsx








function resources_Resources(param) {
    var isDesktop = param.isDesktop;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column, {
                label: "Resources",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/academy",
                        title: "Academy",
                        subTitle: "Learn the basics",
                        icon: Academy
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/blog",
                        title: "Blog",
                        subTitle: "Latest updates from GraphCMS",
                        icon: Paper
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/resources",
                        title: "Resource Hub",
                        subTitle: "Curated resources to help you succeed",
                        icon: Resources
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/events",
                        title: "Events",
                        subTitle: "Come meet us around the world",
                        icon: Calendar
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/newsroom",
                        title: "Newsroom",
                        subTitle: "Latest announcements from the GraphCMS team",
                        icon: Newspaper
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/faq",
                        title: "FAQ",
                        subTitle: "Frequently asked questions from our community",
                        icon: Question
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/write-for-graphcms",
                        title: "Write for GraphCMS",
                        subTitle: "Share your knowledge and help others learn",
                        icon: Write
                    })
                ]
            }),
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCard, {
                        href: "/blog/how-to-migrate-from-monolith-to-modular-dxp",
                        label: "Blog",
                        image: {
                            src: "/images/nav/blog-migrate.svg",
                            blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAIAAAA7ljmRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMElEQVQImWNg5lKb33u3IHEFA4M8g4CY+f8H///f/a+uFMEgLubuZdaxe+5/BgZZABbfDnw51OnJAAAAAElFTkSuQmCC"
                        },
                        title: "Migrate from a monolith to a modern stack"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCard, {
                        href: "/resources/dxp-report-2020",
                        label: "Report",
                        image: dxp_report,
                        title: "Composable architectures for business innovation"
                    })
                ]
            })
        ]
    }));
}

;// CONCATENATED MODULE: ./src/components/nav/content/solutions.tsx







function Solutions(param) {
    var isDesktop = param.isDesktop;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column, {
                label: "Use Cases",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/use-cases/content-federation",
                        title: "Content Federation",
                        subTitle: "Unify your entire stack",
                        icon: Loader
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/use-cases/application-content",
                        title: "Application Content",
                        subTitle: "Ship ambitious products",
                        icon: Paper
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/use-cases/structured-content",
                        title: "Structured Content",
                        subTitle: "Reusable content, API-first",
                        icon: Structure
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column, {
                cta: {
                    href: "/use-cases",
                    title: "View all Use Cases"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/use-cases/agile-ecommerce",
                        title: "eCommerce",
                        subTitle: "Focus on selling",
                        icon: Cart
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/use-cases/portals",
                        title: "Portals",
                        subTitle: "Critical information delivered",
                        icon: Globe
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                        href: "/use-cases/marketing-websites-and-seo",
                        title: "Modern Websites",
                        subTitle: "Build modern experiences",
                        icon: Star
                    })
                ]
            }),
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                cta: {
                    href: "/case-studies",
                    title: "Read Customer Success Stories"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCard, {
                        href: "/case-studies/telenor-case-study",
                        label: "Case Study",
                        image: {
                            src: "/images/nav/telenor.svg",
                            blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAIAAAA7ljmRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJ0lEQVQImWNgEPBh4PdikAoFIQbJ4Lb//xnCZ4CEQDKaaQxK8UAGAI8xB5T+CWFyAAAAAElFTkSuQmCC"
                        },
                        title: "GraphCMS and Telenor"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCard, {
                        href: "/case-studies/2u-case-study",
                        label: "Case Study",
                        image: {
                            src: "/images/nav/2u.svg",
                            blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAIAAAA7ljmRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALElEQVQImWNgkC0BIZUaBoUKBgaGhJRt/4/+/88gkcfAIF3EoNnEYNwFlAcAxcQKo5C6D8QAAAAASUVORK5CYII="
                        },
                        title: "GraphCMS and 2U"
                    })
                ]
            })
        ]
    }));
}

;// CONCATENATED MODULE: ./src/components/nav/content/index.ts





// EXTERNAL MODULE: ./src/contexts/navigation.tsx
var navigation = __webpack_require__(53287);
// EXTERNAL MODULE: ./src/components/nav/main-nav.module.css
var main_nav_module = __webpack_require__(92393);
var main_nav_module_default = /*#__PURE__*/__webpack_require__.n(main_nav_module);
;// CONCATENATED MODULE: ./src/components/nav/main-nav.tsx








var dropdownItems = [
    {
        id: "product",
        title: "Product",
        content: Product
    },
    {
        id: "solutions",
        title: "Solutions",
        content: Solutions
    },
    {
        id: "resources",
        title: "Resources",
        content: resources_Resources
    },
    {
        id: "developers",
        title: "Developers",
        content: Developers
    }, 
];
function MainNav(param) {
    var isDesktop = param.isDesktop;
    var onMouseEnter = function onMouseEnter(dropdown) {
        setActiveDropdown(dropdown);
    };
    var onMouseLeave = function onMouseLeave() {
        setActiveDropdown("");
    };
    var scrollRef = (0,react.useRef)(null);
    var isOpen = (0,navigation/* useNavigationState */.W_)().isOpen;
    var ref = (0,react.useState)(""), activeDropdown = ref[0], setActiveDropdown = ref[1];
    (0,react.useEffect)(function() {
        return function() {
            (0,bodyScrollLock_esm/* clearAllBodyScrollLocks */.tP)();
        };
    }, []);
    (0,react.useEffect)(function() {
        if (!isDesktop) onMouseLeave();
    }, [
        isDesktop
    ]);
    (0,react.useEffect)(function() {
        if (scrollRef.current) {
            if (isOpen) {
                (0,bodyScrollLock_esm/* disableBodyScroll */.Qp)(scrollRef.current);
            } else {
                (0,bodyScrollLock_esm/* enableBodyScroll */.tG)(scrollRef.current);
            }
        }
    }, [
        isOpen
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        ref: scrollRef,
        className: classnames_default()("w-auto flex-col px-4 lg:flex-row lg:items-center lg:justify-center lg:px-0", {
            'hidden lg:flex': !isOpen,
            'mt-6 overflow-y-auto border-gray-300 border-transparent p-4 lg:border-none': isOpen
        }),
        style: {
            WebkitOverflowScrolling: "touch"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onMouseLeave: onMouseLeave,
                className: classnames_default()("justify-center lg:flex lg:flex-row", (main_nav_module_default()).nav),
                children: dropdownItems.map(function(item) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(NavItem, {
                        label: item.title,
                        content: item.content,
                        onMouseEnter: function() {
                            return onMouseEnter(item.id);
                        },
                        dropdownOpen: activeDropdown === item.id,
                        isDesktop: isDesktop
                    }, item.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                label: "Pricing",
                href: "/pricing",
                className: (main_nav_module_default()).pricing
            })
        ]
    }));
}
/* harmony default export */ var main_nav = (/*#__PURE__*/(0,react.memo)(MainNav));

// EXTERNAL MODULE: ./src/hooks/useWindowWidth.ts
var useWindowWidth = __webpack_require__(36230);
// EXTERNAL MODULE: ./src/components/nav/nav.module.css
var nav_module = __webpack_require__(86661);
var nav_module_default = /*#__PURE__*/__webpack_require__.n(nav_module);
// EXTERNAL MODULE: ./node_modules/react-headroom/dist/index.js
var dist = __webpack_require__(51517);
// EXTERNAL MODULE: ./src/components/MenuToggle.tsx + 1 modules
var MenuToggle = __webpack_require__(22918);
;// CONCATENATED MODULE: ./src/components/nav/sticky-nav.tsx










function StickyNav(param) {
    var handleIsFixed = param.handleIsFixed, windowWidth = param.windowWidth;
    var isOpen = (0,navigation/* useNavigationState */.W_)().isOpen;
    var toggleNav = (0,navigation/* useNavigationDispatch */.ES)().toggleNav;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
        pinStart: 60,
        onUnfix: function() {
            return handleIsFixed(true);
        },
        onPin: function() {
            return handleIsFixed(false);
        },
        onUnpin: function() {
            return handleIsFixed(false);
        },
        style: isOpen ? {
            boxShadow: "none"
        } : {},
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("relative mx-auto flex max-w-6xl flex-col py-4 leading-relaxed lg:flex-row lg:justify-between lg:rounded lg:py-8 lg:px-6", {
                'pb-0': isOpen
            }),
            style: {
                perspective: "2000px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-full flex-row items-center justify-between px-6 lg:w-auto lg:px-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: "/",
                            prefetch: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: "GraphCMS"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* default */.Z, {
                                        className: "h-[30px] max-w-[132px] fill-current"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex appearance-none flex-row items-center justify-between lg:hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuToggle/* default */.Z, {
                                className: "-mr-3",
                                onClick: toggleNav,
                                open: isOpen
                            })
                        })
                    ]
                }),
                windowWidth && windowWidth >= 1024 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(main_nav, {
                            isDesktop: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hidden w-auto items-center justify-evenly whitespace-nowrap px-4 lg:flex lg:flex-row lg:px-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        colour: "faded-cornflower",
                                        href: "/contact",
                                        size: "small",
                                        className: "px-4",
                                        children: "Contact sales"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "lg:ml-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        colour: "purple",
                                        href: "https://app.graphcms.com/signup",
                                        size: "small",
                                        className: "px-4",
                                        withArrow: true,
                                        children: "Get started"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
}
/* harmony default export */ var sticky_nav = (/*#__PURE__*/(0,react.memo)(StickyNav));

;// CONCATENATED MODULE: ./src/components/nav/index.tsx

/* eslint-disable consistent-return */ 








function Header() {
    var handleIsFixed = function handleIsFixed(isFixed) {
        setIsFixed(isFixed);
    };
    var ref = (0,react.useState)(true), menuIsFixed = ref[0], setIsFixed = ref[1];
    var windowWidth = (0,useWindowWidth/* useWindowWidth */.L)().windowWidth;
    var isOpen = (0,navigation/* useNavigationState */.W_)().isOpen;
    var closeNav = (0,navigation/* useNavigationDispatch */.ES)().closeNav;
    (0,react.useEffect)(function() {
        if (windowWidth && windowWidth >= 1024) closeNav();
    }, [
        windowWidth
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("z-modal w-full text-current", isOpen ? "fixed inset-0 bg-white !text-haiti" : "relative", (nav_module_default()).nav, menuIsFixed ? (nav_module_default()).navWithBanner : (nav_module_default()).navWithoutBanner),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, {
                    className: menuIsFixed ? "block" : "hidden"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(sticky_nav, {
                    handleIsFixed: handleIsFixed,
                    windowWidth: windowWidth
                }),
                windowWidth && windowWidth < 1024 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(main_nav, {
                            isDesktop: false
                        }),
                        isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "z-50 flex w-full flex-col border-t border-catskill-white bg-white p-2 lg:border-t-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    href: "https://app.graphcms.com/signup",
                                    size: "large",
                                    colour: "faded-cornflower",
                                    onClick: closeNav,
                                    children: "Get started"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    href: "/contact",
                                    size: "large",
                                    colour: "purple",
                                    className: "mt-4",
                                    children: "Contact sales"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./src/components/SEO.tsx
var SEO = __webpack_require__(11098);
;// CONCATENATED MODULE: ./src/components/Layout/Vanilla.tsx






function Vanilla_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Vanilla_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Vanilla_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var DynamicPreviewBanner = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 4065).then(__webpack_require__.bind(__webpack_require__, 4065));
});
function VanillaLayout(param) {
    var children = param.children, _removeSalesBreakpoint = param.removeSalesBreakpoint, removeSalesBreakpoint = _removeSalesBreakpoint === void 0 ? false : _removeSalesBreakpoint, seo = param.seo, preview = param.preview;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Base/* default */.Z, {
        children: [
            preview && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicPreviewBanner, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, Vanilla_objectSpread({}, seo)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-12",
                children: [
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                        removeSalesBreakpoint: removeSalesBreakpoint
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 67576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Section; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


function Section(param) {
    var children = param.children, className = param.className, _colour = param.colour, colour = _colour === void 0 ? "transparent" : _colour, _size = param.size, size = _size === void 0 ? "regular" : _size, _container = param.container, container = _container === void 0 ? "regular" : _container;
    var sizeClass = function(sizeParam) {
        switch(sizeParam){
            case "small":
                return "py-8 md:py-16";
            case "regular":
            default:
                return "py-12 md:py-24";
        }
    };
    var colourClass = function(colourParam) {
        switch(colourParam){
            case "dark":
                return "bg-haiti text-white";
            case "light":
                return "bg-whisper";
            case "white":
                return "bg-white";
            case "transparent":
            default:
                return null;
        }
    };
    var widthClass = function(containerParam) {
        switch(containerParam){
            case "narrower":
                return "max-w-3xl";
            case "narrow":
                return "max-w-4xl";
            case "regular":
            default:
                return "max-w-6xl";
        }
    };
    var containerClass = classnames__WEBPACK_IMPORTED_MODULE_1___default()("mx-auto px-6", widthClass(container));
    var sectionClass = classnames__WEBPACK_IMPORTED_MODULE_1___default()(colourClass(colour), sizeClass(size), className);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: sectionClass,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: containerClass,
            children: children
        })
    }));
};


/***/ }),

/***/ 38790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SectionHero; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68663);
/* harmony import */ var _components_renderers_Heading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27910);
/* harmony import */ var _components_renderers_Paragraph__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37324);




function SectionHero(param) {
    var pretext = param.pretext, title = param.title, description = param.description, ctas = param.ctas, noHr = param.noHr;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mx-auto mb-6 max-w-4xl lg:mb-12 lg:text-center",
        children: [
            !noHr && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                className: "inline-block h-1 w-24 rounded border-0 bg-cornflower md:w-48"
            }),
            pretext && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "-mb-8 text-xs font-semibold uppercase tracking-wide text-cornflower",
                children: pretext
            }),
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_renderers_Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                level: 2,
                children: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_renderers_Paragraph__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: description
            }),
            ctas && ctas.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-6 inline-flex flex-col space-x-0 space-y-4 sm:flex-row sm:items-center sm:space-x-4 sm:space-y-0",
                children: ctas.map(function(cta) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        colour: cta.colour || 'pink',
                        appearance: cta.appearance,
                        href: cta.href,
                        children: [
                            cta.label || 'Learn more',
                            " →"
                        ]
                    }, cta.href);
                })
            })
        ]
    }));
};


/***/ }),

/***/ 39685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jl": function() { return /* reexport */ Businesses; },
  "y2": function() { return /* reexport */ Creators; },
  "se": function() { return /* reexport */ Engineering; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/icons/personas/businesses.tsx

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Businesses(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", _objectSpread({
        width: 22,
        height: 22,
        viewBox: "0 0 22 22",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 13.951V0h16.634v16.634H0V13.95zm13.951 0V2.683H2.683V13.95H13.95z",
                fill: "currentColor",
                fillOpacity: 0.3
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.317 5.367H5.366V22H22V5.367h-2.683zm0 2.682H8.05v11.269h11.268V8.049z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#EBF4FF",
                d: "M13.952 5.367h2.683V8.05h-2.683zM5.366 13.951h2.683v2.683H5.366z"
            })
        ]
    })));
};

;// CONCATENATED MODULE: ./src/components/icons/personas/creators.tsx

function creators_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function creators_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            creators_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Creators(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", creators_objectSpread({
        width: 22,
        height: 22,
        viewBox: "0 0 22 22",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: 0.8,
                fill: "currentColor",
                d: "M6.079 6.078h4.053v4.053H6.079z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: 0.4,
                fill: "currentColor",
                d: "M6.079 11.867h4.053v4.053H6.079z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: 0.6,
                fill: "currentColor",
                d: "M11.868 6.078h4.053v4.053h-4.053z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: 0.2,
                fill: "currentColor",
                d: "M11.868 11.867h4.053v4.053h-4.053z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.105 0H0v22h22V0h-2.895zm0 2.895H2.895v16.21h16.21V2.895z",
                fill: "currentColor"
            })
        ]
    })));
};

;// CONCATENATED MODULE: ./src/components/icons/personas/engineering.tsx

function engineering_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function engineering_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            engineering_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Engineering(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", engineering_objectSpread({
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "6.95996",
                y: "3.70074",
                width: "4.62768",
                height: "2.8923",
                fill: "currentColor",
                fillOpacity: "0.4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "6.95996",
                y: "9.48566",
                width: "4.62768",
                height: "2.8923",
                fill: "currentColor",
                fillOpacity: "0.4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "6.95996",
                y: "15.2706",
                width: "4.62768",
                height: "2.8923",
                fill: "currentColor",
                fillOpacity: "0.4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.6859 9.48613V12.3788H11.5874V15.2711H19.6859V18.1628H11.5874V21.0551H21.9997L21.9997 21.0548V3.70109H21.9999V0.808792H21.9997V0.808716H19.6859V0.808792H11.5876V3.70109H19.6859V6.59383H11.5874V9.48613H19.6859Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "2.62137",
                cy: "5.14709",
                r: "1.73538",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                opacity: "0.7",
                cx: "2.62137",
                cy: "11.221",
                r: "1.73538",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                opacity: "0.3",
                cx: "2.62137",
                cy: "17.295",
                r: "1.73538",
                fill: "currentColor"
            })
        ]
    })));
};

;// CONCATENATED MODULE: ./src/components/icons/personas/index.ts





/***/ }),

/***/ 27910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RendererHeading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34465);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function RendererHeading(_param) {
    var className = _param.className, props = _objectWithoutProperties(_param, [
        "className"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Heading__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("mt-12", className)
    }, props)));
};


/***/ }),

/***/ 37324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Paragraph; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Paragraph(_param) {
    var children = _param.children, className = _param.className, _size = _param.size, size = _size === void 0 ? "large" : _size, props = _objectWithoutProperties(_param, [
        "children",
        "className",
        "size"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", _objectSpread({
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("leading-loose", className, {
            'my-1 text-sm md:my-2 lg:my-4': size === "small",
            'my-3 md:my-4 lg:my-6': size === "large"
        })
    }, props, {
        children: children
    })));
};


/***/ }),

/***/ 29320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useIsomorphicLayoutEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : 0;


/***/ }),

/***/ 36230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useWindowWidth; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93096);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29320);



function useWindowWidth() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), windowWidth = ref[0], setWindowWidth = ref[1];
    (0,_hooks_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicLayoutEffect */ .L)(function() {
        var handleWindowWidthChange = lodash_throttle__WEBPACK_IMPORTED_MODULE_1___default()(function() {
            return setWindowWidth(window.innerWidth);
        }, 500);
        window.addEventListener("resize", handleWindowWidthChange);
        handleWindowWidthChange();
        return function() {
            return window.removeEventListener("resize", handleWindowWidthChange);
        };
    }, [
        windowWidth
    ]);
    return {
        windowWidth: windowWidth
    };
}


/***/ }),

/***/ 25985:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"dropdown_dropdown__CKH6T"};

/***/ }),

/***/ 7924:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"item_dropdown__DPjwp","open":"item_open__fJeLz"};

/***/ }),

/***/ 92393:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nav":"main-nav_nav__gcHSM","pricing":"main-nav_pricing__EFwa9"};

/***/ }),

/***/ 86661:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav_nav__VHVL7","navWithBanner":"nav_navWithBanner__4sHZ5","navWithoutBanner":"nav_navWithoutBanner__2CME4"};

/***/ })

}]);